import a from "./td-longtail-vue-components103.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var r = function() {
  var s = this, t = s._self._c, e = s._self._setupProxy;
  return s.text ? t(s.tag, { tag: "component", staticClass: "heading", class: e.classes, domProps: { innerHTML: s._s(s.text) } }) : t(s.tag, { tag: "component", staticClass: "heading", class: e.classes }, [s._t("default")], 2);
}, o = [], _ = /* @__PURE__ */ n(
  a,
  r,
  o,
  !1,
  null,
  "28fb712a"
);
const f = _.exports;
export {
  f as default
};
